/**
 * Lightbox for the CGF Gallery block.
 *
 * GLightbox (MIT, no dependencies). Its stylesheet is imported here rather
 * than enqueued separately so Vite bundles it with the rest of the theme CSS.
 *
 * One instance covers every gallery on the page: GLightbox groups slides by
 * the value of each link's data-gallery attribute, and the block gives each
 * gallery its own value. Without that grouping two galleries on one page would
 * page into each other as a single set.
 *
 * Thumbnails are plain links to the full-size file, so the gallery still works
 * with JavaScript off; this only takes over the click.
 */

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

function init() {
    if (!document.querySelector('.cgf-gallery__link')) {
        return;
    }

    GLightbox({
        selector: '.cgf-gallery__link',
        // Captions come from data-description on each link.
        openEffect: 'fade',
        closeEffect: 'fade',
        slideEffect: 'slide',
        loop: true,
        touchNavigation: true,
        keyboardNavigation: true,
        // The counter tells you how far through a long gallery you are.
        moreLength: 0,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
